<template>
    <v-row class="d-flex" v-if="!resourceLoading && resource" style="max-width: 1500px">
        <v-col cols="12" xl="10" lg="10" md="10" sm="12">
            <div class="float-right">
                <ShareButton :title="resource.name"/>
            </div>
            <h1 class="mt-0 mb-auto pb-0 vs-header">
                {{ resource.name }}
                <template v-if="resource.year">
                    ({{resource.year}})
                </template>
            </h1>

            <h2 class="mb-4 mt-1">
                <template v-if="resource.genres && resource.genres[0]">
                    {{ resource.genres[0].name }}
                </template>
                <template v-if="resource.genres && resource.genres[1]">
                    / {{ resource.genres[1].name }}
                </template>
                {{ $t('movie type '+resource.type) }}
            </h2>

            <v-row
                dense
                class="header-box"
            >
                <v-col
                    cols="12"
                    xl="3"
                    lg="4"
                    md="4"
                    sm="4"
                    class="text-center"
                >
                    <!-- movie  picture
                    <listing-picture
                        :picture="resource.picture"
                        :alt="$t('open')"
                        size="md"
                        direction="front"
                        :class="{'cursor-pointer': resource.picture}"
                        :link="resource.picture ? 'dialog' : false"
                        @openDialog="!dialog ? dialog = true : dialog = false"
                        :user_flag="userFlag"
                    ></listing-picture>
                    -->
                    <v-img
                        :alt="$t('open')"
                        :title="resource.name"
                        class="vs-profile-picture"
                        :class="{
                            'cursor-pointer': resource.picture,
                            'my_entries': resource.list_entries_count_auth,
                            'my_wanted': resource.seen_count_auth,
                            'my_owned': resource.want_see_count_auth,
                            }"
                        :lazy-src="imgSrc(resource.picture, 'xs', 'front')"
                        :src="imgSrc(resource.picture, 'sm', 'front')"
                        @click="resource.picture ? dialog = true : false"
                        contain
                        width="100%"
                    />
                </v-col>
                <v-col
                    cols="8"
                    xl="9"
                    lg="8"
                    md="8"
                    sm="8"
                    class="hidden-xs-only"
                >

                    <!-- basic info -->
                    <details-table :resources="basicInfo" />

                    <v-btn v-if="resource.trailer" @click="dialog_video = true" class="v-positive-button mt-3 mr-1" small>
                        <v-icon>mdi-eye</v-icon>
                        {{ $t('watch trailer') }}
                    </v-btn>

                    <!-- rating -->
                    <v-chip class="mt-3 mr-1" small :x-small="this.$vuetify.breakpoint.name == 'xs'" :title="$t('rating')">
                        <v-rating
                            length="5"
                            :half-increments="true"
                            color="yellow"
                            background-color="grey"
                            readonly
                            dense
                            :x-small="this.$vuetify.breakpoint.name == 'xs'"
                            :value="resource.user_reviews_rating"
                            :title="$t('rating')+': '+resource.user_reviews_rating+' '"
                        ></v-rating>
                        <b class="smaller-txt" v-if="resource.user_reviews_count > 0">{{ resource.user_reviews_count }}</b>
                        <b class="smaller-txt" v-else>0</b>
                    </v-chip>

                    <v-chip class="mr-1 mt-3" small
                            :title="$t('likes')"
                            :color="resource.likes_count_auth ? 'green':null"
                    >
                        <v-icon x-small class="mr-1" >mdi-heart</v-icon>
                        <b class="smaller-txt">{{ resource.likes_count }}</b>
                    </v-chip>

                    <!-- posts -->
                    <v-chip class="mr-1 mt-3" small :title="$t('comments')"
                    >
                        <v-icon x-small class="mr-1">mdi-comment</v-icon>
                        <b class="smaller-txt">{{ resource.posts_count }}</b>
                    </v-chip>

                    <!-- subPageButtons for large screens -->
                    <!--
                    <sub-page-buttons
                        class="mt-4 hidden-xs-only"
                        :buttons="subPageButtons"
                        @openDialog="$store.state.auth_user ? dialog_delete = true : $root.$emit('login-prompt')"
                        :route="subPage"
                        :base_url="'/'+baseUrl+'/'+publicId"
                    >
                    </sub-page-buttons>
                    -->
                </v-col>
                <v-col
                    cols="12"
                >
                    <!-- subPageButtons for large screens -->
                    <sub-page-buttons
                        :buttons="subPageButtons"
                        @openDialog="$store.state.auth_user ? dialog_delete = true : $root.$emit('login-prompt')"
                        :route="subPage"
                        :base_url="'/'+baseUrl+'/'+publicId"
                    >
                    </sub-page-buttons>
                </v-col>
            </v-row>

            <keep-alive>

                <!-- main page -->
                <v-row
                    v-if="!subPage"
                    >

                    <v-col
                        cols="12"
                    >
                        <!--
                        <div v-html="resource.description" class="vs-long-text nl-break"></div>
                        -->
                        <template v-if="resource.description">
                            <h3 class="headline sentence-caps" v-html="$t('story synopsis')" id="description"/>
                            <template v-if="wordCount(resource.description) > 53 && !showAllStory">
                                <div v-html="cutStringByWords(resource.description, 53)" class="nl-break"></div>
                                <div class="vs-link float-right" @click="showAllStory = true">{{ $t('show more') }}<v-icon x-small>mdi-arrow-down</v-icon></div>
                            </template>
                            <template v-else>
                                <div v-html="resource.description" class="nl-break"></div>
                                <div v-if="wordCount(resource.description) > 53" class="vs-link float-right" @click="showAllStory = false; $vuetify.goTo('#description', goToParams)">{{ $t('show less') }}<v-icon x-small>mdi-arrow-up</v-icon></div>
                            </template>
                            <!--</transition>-->
                            <v-divider class="mt-5"></v-divider>
                        </template>

                        <!-- user has it -->
                        <template v-if="resource.user_releases_count > 0">
                            <router-link :to="'/movie/'+resource.public_id+'/releases'" v-if="resource.user_releases_count > 4" class="float-right mt-3 smaller-txt">
                                {{ $t('all releases') }} <v-icon small>mdi-arrow-right</v-icon>
                            </router-link>
                            <h2 class="headline sentence-caps">{{ $t('you have it')}} ({{ resource.user_releases_count }})</h2>
                            <div class="vertical-list">
                                <list-browser
                                    class="mt-5"
                                    :key="'releases'"
                                    type="releases"
                                    api-route="releases_view"
                                    :api-params="{
                                      parent_model: 'title',
                                      parent_id: this.resource.public_id,
                                      fi: 'on_owned_list',
                                      take: 4,
                                      so: 'format'
                                    }"
                                    :disable-divider="true"
                                    :hide-control-buttons="true"
                                    :hide-results-ui="true"
                                    hide-bottom-navi
                                    :hide-search="true"
                                    search-placeholder="search other releases"
                                    default_item_component="ItemPicture"
                                    :dialog_buttons="[]"
                                    :dialogs="{}"
                                    :dialog_properties="[]"
                                    :dialog_sources="{}"
                                    :hide_dialogs="{}"
                                    :reaction_buttons="true"
                                    picture-listing-label="format"
                                    >
                                </list-browser>
                            </div>
                            <v-divider class="mt-5"></v-divider>
                        </template>

                        <!-- top releases -->
                        <template v-if="resource.releases_count > 0">
                            <router-link :to="'/movie/'+resource.public_id+'/releases'" v-if="resource.releases_count > 4" class="float-right mt-3 smaller-txt">
                                {{ $t('all releases') }} <v-icon small>mdi-arrow-right</v-icon>
                            </router-link>
                            <h2 class="headline sentence-caps">{{ $t('top releases')}}</h2>
                            <div class="vertical-list">

                                <!-- releases for the title -->
                                <list-browser
                                    class="mt-5"
                                    :key="'releases'"
                                    :id="catalogueID"
                                    type="releases"
                                    api-route="releases_view"
                                    :api-params="{
                                      parent_model: 'title',
                                      parent_id: this.resource.public_id,
                                      so: 'format',
                                      take: 4,
                                    }"
                                    :disable-divider="true"
                                    :hide-control-buttons="true"
                                    :hide-results-ui="true"
                                    hide-bottom-navi
                                    :hide-search="true"
                                    search-placeholder="search other releases"
                                    default_item_component="ItemPicture"
                                    :dialog_buttons="[]"
                                    :dialogs="{}"
                                    :dialog_properties="[]"
                                    :dialog_sources="{}"
                                    :hide_dialogs="{}"
                                    :reaction_buttons="true"
                                    picture-listing-label="format"
                                />
                            </div>
                            <v-divider class="mt-5"></v-divider>
                        </template>

                        <!-- user reviews -->
                        <template v-if="resource.user_reviews_count > 0">
                            <router-link :to="'/movie/'+resource.public_id+'/reviews'" v-if="resource.user_reviews_count > 4" class="float-right mt-3 smaller-txt">
                                {{ $t('all reviews') }} <v-icon small>mdi-arrow-right</v-icon>
                            </router-link>
                            <h2 class="headline sentence-caps">{{ $t('user reviews')}}</h2>
                            <div class="vertical-list">
                                <!-- reviews -->
                                <list-browser
                                    class="mt-1"
                                    :key="'reviews'"
                                    :id="catalogueID"
                                    type="reviews"
                                    api-route="reviews_parent"
                                    :api-params="{
                                      parent_model: 'title',
                                      parent_id: this.resource.id,
                                      take: 4,
                                    }"
                                    :disable-divider="true"
                                    :hide-control-buttons="true"
                                    :hide-results-ui="true"
                                    hide-bottom-navi
                                    :hide-search="true"
                                    search-placeholder="search reviews"
                                    default_item_component="ItemPicture"
                                    :dialog_buttons="[]"
                                    :dialogs="{}"
                                    :dialog_properties="[]"
                                    :dialog_sources="{}"
                                    :hide_dialogs="{}"
                                    picture-listing-label="rating"
                                />
                            </div>
                            <v-divider class="mt-5"></v-divider>
                        </template>

                        <!-- xs ads -->
                        <template v-if="$vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'">
                            {{ $t('movie deals') }}
                            <ShoppingLinks
                                :resource-links="resource.shopping_links"
                                :fall-back-picture="resource.picture"
                                :general-links-fixed-height="80"
                                :keyword="resource.name+' '+resource.year"
                                :parent-model="resource.model"
                                :parent-id="resource.id"
                                :mode="2"
                                :user-login="Boolean($store.state.auth_user)"
                                class="mb-3"
                            />
                        </template>
                        <!-- details section -->
                        <h2 class="headline">{{ $t('details')}}</h2>
                        <!-- full info -->
                        <details-table :resources="completeInfo" class="mb-16" />
                    </v-col>
                </v-row>

                <!-- releases for the title :id="catalogueID" -->
                <list-browser
                    v-if="subPage === '/releases'"
                    :key="'releases'"
                    type="releases"
                    api-route="releases_view"
                    :api-params="{
                      parent_model: 'title',
                      parent_id: this.resource.public_id,
                      so: 'format',
                    }"
                    search-placeholder="search release name"
                    default_item_component="ItemPicture"
                    :dialog_buttons="releaseDialogs.buttons"
                    :dialogs="releaseDialogs.visibility"
                    :dialog_sources="releaseDialogs.sources"
                    :dialog_properties="releaseDialogs.properties"
                    :reaction_buttons="true"
                    :hide_dialogs="{}"
                    :master-link="{
                        'label': $t('add new release'),
                        'icon': 'mdi-plus-box-outline',
                        'to': '/movie/'+resource.public_id+'/releases/new'
                    }"
                    picture-listing-label="label"
                    :custom-zero-results-message="$t('no releases')"
                >
                </list-browser>

                <!-- reviews -->
                <list-browser
                    class="mt-1"
                    v-if="subPage === '/reviews'"
                    :key="'reviews'"
                    :id="catalogueID"
                    type="reviews"
                    api-route="reviews_parent"
                    :api-params="{
                      parent_model: 'title',
                      parent_id: this.resource.id,
                    }"
                    search-placeholder="search reviews"
                    default_item_component="ItemPictureTextInfo"
                    :dialog_buttons="[]"
                    :dialogs="{}"
                    :dialog_properties="[]"
                    :dialog_sources="{}"
                    :hide_dialogs="{}"
                    :hide-search="true"
                    :reaction_buttons="true"
                    :master-link="{
                        'label': $t('write a review'),
                        'icon': 'mdi-pencil-plus-outline',
                        'to': '/movie/'+resource.public_id+'/reviews/new'
                    }"
                    picture-listing-label="rating"
                    disable-view-button
                    :custom-zero-results-message="$t('no reviews yet')"
                >
                </list-browser>

                <!-- cast & and crew -->
                <list-browser
                    v-if="subPage === '/cast_crew'"
                    :key="'cast_crew'"
                    :id="catalogueID"
                    type="crew"
                    api-route="cast_crew"
                    :api-params="{
                      parent_model: 'title',
                      parent_id: this.resource.id,
                      so: 'group'
                    }"
                    :hide-search="false"
                    :hide-ads="true"
                    search-placeholder="search person name character name"
                    default_item_component="ItemPicture"
                    :dialog_buttons="[]"
                    :dialogs="{}"
                    :dialog_properties="[]"
                    :dialog_sources="{}"
                    :reaction_buttons="false"
                    :hide_dialogs="{}"
                    :master-link="{
                        'label': $t('edit cast and crew'),
                        'icon': 'mdi-square-edit-outline',
                        'to': '/movie/'+resource.public_id+'/edit/crew'
                    }"
                    picture-listing-label="crew"
                >
                </list-browser>
                <!-- // cast & and crew -->

                <!-- movie connections -->
                <list-browser
                    class="mt-5"
                    v-if="subPage === '/movie_connections'"
                    :key="'movie_connections'"
                    :id="catalogueID"
                    type="movie_connections"
                    api-route="movie_connections"
                    :api-params="{
                      parent_model: 'title',
                      parent_id: this.resource.id,
                      so: 'type'
                    }"
                    search-placeholder="search"
                    default_item_component="ItemPictureTextInfo"
                    :hide-search="true"
                    :dialog_buttons="[]"
                    :dialogs="{}"
                    :dialog_properties="[]"
                    :dialog_sources="{}"
                    :reaction_buttons="true"
                    :hide_dialogs="{}"
                    :master-link="{
                        'label': $t('edit movie connections'),
                        'icon': 'mdi-square-edit-outline',
                        'to': '/movie/'+resource.public_id+'/edit/connections'
                    }"
                    :custom-zero-results-message="$t('no movie connections')"
                >
                </list-browser>
                <!-- // movie connections -->

                <!-- photos -->
                <list-browser
                    class="mt-1"
                    v-if="subPage === '/photos'"
                    :key="'photos'"
                    :id="catalogueID"
                    type="photos"
                    api-route="photos_"
                    :api-params="{
                      parent_model: 'title',
                      parent_id: this.resource.id,
                    }"
                    search-placeholder="search reviews"
                    default_item_component="ItemPicture"
                    :dialog_buttons="[]"
                    :dialogs="{}"
                    :dialog_properties="[]"
                    :dialog_sources="{}"
                    :hide_dialogs="{}"
                    :hide-search="true"
                    :hide-control-buttons="true"
                    :reaction_buttons="false"
                    :custom-zero-results-message="$t('no pictures adding not supported')"
                >
                </list-browser>
                <!-- // photos -->

                <!-- videos -->
                <list-browser
                    class="mt-1"
                    v-if="subPage === '/videos'"
                    :key="'videos'"
                    :id="catalogueID"
                    type="videos"
                    api-route="videos_"
                    :api-params="{
                      parent_model: 'title',
                      parent_id: this.resource.id,
                    }"
                    search-placeholder="search videos"
                    default_item_component="ItemPicture"
                    :dialog_buttons="[]"
                    :dialogs="{}"
                    :dialog_properties="[]"
                    :dialog_sources="{}"
                    :hide_dialogs="{}"
                    :hide-search="true"
                    :hide-control-buttons="true"
                    :reaction_buttons="false"
                    :master-link="{
                        'label': $t('add video'),
                        'icon': 'mdi-plus-box-outline',
                        'to': '/movie/'+resource.public_id+'/videos/new'
                    }"
                    :custom-zero-results-message="$t('no videos')"
                >
                </list-browser>
                <!-- // videos -->

                <!-- user_collections -->
                <list-browser
                    v-if="subPage === '/user_collections'"
                    :key="'user_collections'"
                    :id="catalogueID"
                    type="user_collections_release"
                    api-route="entries_parent"
                    :api-params="{
                      parent_model: 'title',
                      parent_id: this.resource.id,
                      so: 'style_asc',
                      rus: true
                    }"
                    search-placeholder="search"
                    default_item_component="ItemPictureTextInfo"
                    :dialog_buttons="[]"
                    :dialogs="{}"
                    :dialog_properties="[]"
                    :dialog_sources="{}"
                    :hide_dialogs="{}"
                    :hide-search="true"
                    picture-listing-label="collection"
                    disable-view-button
                    :custom-zero-results-message="$t('not in user collections')"
                >
                </list-browser>
                <!-- // user_collections -->

                <!-- posts -->
                <list-browser
                    class="mt-1"
                    v-if="subPage === '/posts'"
                    :key="'posts'"
                    :id="catalogueID"
                    type="posts"
                    api-route="posts"
                    :api-params="{
                      parent_model: 'title',
                      parent_id: this.resource.id,
                    }"
                    search-placeholder="search posts"
                    default_item_component="ItemPictureTextInfo"
                    :dialog_buttons="[]"
                    :dialogs="{}"
                    :dialog_properties="[]"
                    :dialog_sources="{}"
                    :hide_dialogs="{}"
                    :hide-search="true"
                    :master-link="{
                        'label': $t('write a post'),
                        'icon': 'mdi-pencil-plus-outline',
                        'to': '/movie/'+resource.public_id+'/posts/new'
                    }"
                    :custom-zero-results-message="$t('no posts')"
                >
                </list-browser>
                <!-- // posts -->

                <!-- buying_options -->
                <BuyingOptions
                    v-if="subPage === '/buying_options' && resource"
                    take="30"
                    horizontal="true"
                    :parent_id="resource.public_id"
                    :parent_model="resource.model.toLowerCase()"
                    :format_id="null"
                    :keyword="resource.name"
                    :campaign_ids="{amazon: 'release_b'}"
                >
                </BuyingOptions>
                <!-- // buying_options -->

                <!-- history -->
                <list-browser
                    class="mt-1"
                    v-if="subPage === '/history'"
                    :key="'history'"
                    :id="catalogueID"
                    type="history"
                    api-route="history"
                    :api-params="{
                      ti: this.resource.id,
                      rus: true,
                      rmo: true,
                    }"
                    default_item_component="ChangesPictureTextInfo"
                    :dialog_buttons="[]"
                    :dialogs="{}"
                    :dialog_properties="[]"
                    :dialog_sources="{}"
                    :hide_dialogs="{}"
                    :hide-search="true"
                    :reaction_buttons="false"
                    heading="page history"
                    :custom-zero-results-message="$t('no history')"
                    disable-view-button
                >
                </list-browser>
                <!-- //history -->
                <contact-form
                    v-if="subPage === '/contact'"
                    model="movie"
                    :public-id="resource.public_id"
                    :auth-user="$store.state.auth_user"
                ></contact-form>

            </keep-alive>

        </v-col>
        <!-- large screen shopping links -->
        <v-col xl="2" lg="2" md="2" cols="12" v-if="$vuetify.breakpoint.name != 'xs' && $vuetify.breakpoint.name != 'sm'">
            <ShoppingLinks
                :resource-links="resource.shopping_links"
                :fall-back-picture="resource.picture"
                :general-links-fixed-height="120"
                :keyword="resource.name+' '+resource.year"
                :format-id="null"
                :parent-model="resource.model"
                :parent-id="resource.id"
                :user-login="Boolean($store.state.auth_user)"
                :mode="1"
                class="mb-16"
            />
        </v-col>

        <!-- the bottom menu -->
        <v-bottom-navigation
            app
            fixed
            align="center"
        >
            <user-action-buttons
                :buttons="userActionButtons"
                @add_want_see="resource.want_see_count_auth++;resource.list_entries_count_auth++;snackbar=true;snackbar_message=$t('added to list', [$event])"
                @sub_want_see="resource.want_see_count_auth--;resource.list_entries_count_auth--;snackbar=true;snackbar_message=$t('removed from list', [$event])"
                @increaseSeenValue="resource.seen_count_auth++;resource.list_entries_count_auth++;snackbar=true;snackbar_message=$t('added to list', [$event])"
                @decreaseListValue="resource.list_entries_count_auth--;snackbar=true;snackbar_message=$t('removed from list', [$event])"
                @increaseLikesValue="resource.likes_count_auth++;resource.likes_count++;snackbar=true;snackbar_message=$t('you like this')"
                @decreaseLikesValue="resource.likes_count_auth--;resource.likes_count--;snackbar=true;snackbar_message=$t('like removed')"
                @openList="$root.$emit('user-collections', resource)"
            >
            </user-action-buttons>
        </v-bottom-navigation>

        <!-- snackbar for brief messages -->
        <v-snackbar
            v-model="snackbar"
            :timeout="snackbar_timeout"
            color="green"
            style="bottom:70px;"
        >
            <div class="text-center">
                {{ snackbar_message }}
            </div>
        </v-snackbar>

        <!-- photo dialog -->
        <v-dialog
            v-model="dialog"
            max-width="1200px"
        >
            <PhotosDialog
                :item="resource.picture"
                @dialog="dialog = $event"
            >
            </PhotosDialog>
        </v-dialog>
        <!-- video dialog -->
        <v-dialog
            v-model="dialog_video"
            max-width="800px"
        >
            <VideoPlayer
                :item="resource.trailer"
                @dialog="dialog_video = $event"
            ></VideoPlayer>
        </v-dialog>

        <!-- dialog_delete dialog -->
        <v-dialog
            v-model="dialog_delete"
            max-width="500"
        >
            <v-card color="red" class="darken-3">
                <v-card-title>{{ $t('delete') }} {{ $t('movie') }}</v-card-title>

                <v-card-text>
                    {{ $t('delete release hint') }}
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        color="red"
                        @click="deleteMovie"
                    >
                        {{ $t('confirm delete') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-row>
    <v-skeleton-loader
        v-else
        style="max-width: 1500px"
        type="article"
    />
</template>

<script>
import useApiResource from '@/composables/useApiResource'
import useDialogsResource from "../composables/useDialogsResource";
import useImgMethods from "../composables/useImgMethods";
import useStringMethods from "../composables/useStringMethods";
const SubPageButtons = () => import("@/components/SubPageButtons.vue");
const BuyingOptions  = () => import("@/components/misc/BuyingOptions.vue");
const userActionButtons = () => import("@/components/UserActionButtons.vue");
const listBrowser = () => import("@/components/ListBrowser.vue");
//const ListingPicture = () => import("@/components/listings/ListingPicture.vue");
const DetailsTable = () => import("@/components/DetailsTable.vue");
const PhotosDialog = () => import("@/components/dialogs/PhotosDialog.vue");
const VideoPlayer = () => import("@/components/videoPlayer.vue");
const ContactForm = () => import("@/components/ContactForm.vue");
const ShareButton = () =>  import("@/components/ShareButton.vue");
const ShoppingLinks = () =>  import("@/components/ShoppingLinks.vue");
export default {
    name: "Movie",
    components: {
        ShoppingLinks,
        VideoPlayer,
        PhotosDialog,
        DetailsTable,
        //ListingPicture,
        BuyingOptions,
        SubPageButtons,
        userActionButtons,
        listBrowser,
        ContactForm,
        ShareButton
    },
    props: {
        baseUrl: String,
        resourcePath: String,
        resourceParams: Object,
        publicId: String,
        subPage: String,
        pre_meta_name: String,
        pre_meta_description: String,
    },
    setup(props) {
        const { resource, resourceLoading, getResource } = useApiResource(props)
        const { releaseDialogs, movieDialogs,reviewDialogs } = useDialogsResource()
        const { imgSrc, clickPicture } = useImgMethods()
        const { cutStringByWords, wordCount } = useStringMethods()

        return {
            resource,
            resourceLoading,
            getResource,
            releaseDialogs,
            movieDialogs,
            reviewDialogs,
            imgSrc,
            clickPicture,
            cutStringByWords,
            wordCount
        }
    },
    metaInfo() {
        return {
            title: this.metaName,
            meta: [
                {property: 'og:title', content: this.metaName},
                {name: 'description', content: this.metaDescription},
                {property: 'og:site_name', content: 'VideoSpace'},
                {property: 'og:type', content: 'website'},
                {name: 'robots', content: this.$t('robots meta')}
            ],
            link: [
                { rel: 'canonical', href: 'https://videospace.fi/movie/'+this.resource.public_id+(this.subPage != '/' ? this.subPage : '') }
            ]
        }
    },
    data: function () {
        return {
            catalogueID: 'catalogue',
            dialog: false,
            dialog_video: false,
            snackbar: false, //snackbar notification open or clase
            snackbar_message: null, //message
            snackbar_timeout: 3000, //time
            dialog_delete: false,
            showAllStory: false,
            goToParams: {
                duration: 100,
                offset: 150,
                easing: 'easeInOutCubic',
            }
        }
    },
    watch:{
        $route(to){
            if(to.name === 'Movie')
                //if route is Movie and if reset_movie is set in any referring view
                if(this.$store.state.reset_title) {
                    this.$store.commit('resetTitle', false) //reset reset_release state into false
                    this.getResource() //refresh resource
                    }
        }
    },
    methods: {
        deleteMovie() {
            this.axios.delete('/titles/' + this.resource.id).then((response) => {
                this.dialog_delete = false
                if (response.data.status == 'waiting')
                    this.$root.$emit('snackbar', {'message': this.$t('delete request sent'), 'color': 'green'})
                else {
                    this.$root.$emit('snackbar', {'message': this.$t('deleted'), 'color': 'green'})
                    setTimeout(
                        function () {
                            window.location.href = '/movies'
                        }, 2000
                    )
                }

            })
        }
    },
    computed: {
        metaName(){

            let meta = this.pre_meta_name
            if(this.resource.id){
                meta = this.resource.name
                meta += this.resource.year ? ' ('+this.resource.year+')' : ''
            }
            return meta

        },
        metaDescription(){

            let meta = this.pre_meta_description
            if(this.resource.id){
                meta = this.resource.name
                meta += this.resource.genres.length > 0 ? ', '+this.resource.genres[0].name : ''
                meta += this.resource.genres.length > 1 ? ' '+this.resource.genres[1].name : ''
                meta += this.resource.type ? ' '+this.$t('movie type '+this.resource.type) : ''
                meta += this.resource.countries.length > 0 ? ' '+this.resource.countries[0].name : ''
                meta += this.resource.year ? ' ('+this.resource.year+')' : ''
                meta += this.resource.directors.length > 0 ? ' Director: '+this.resource.directors[0].name : ''
                meta += this.resource.actors.length > 0 ? ' Starring: '+this.resource.actors[0].name : ''
                meta += this.resource.actors.length > 1 ? ', '+this.resource.actors[1].name : ''
                meta += this.resource.actors.length > 2 ? ', '+this.resource.actors[2].name : ''
                meta += this.resource.actors.length > 3 ? '...' : ''
                if(this.resource.user_reviews_rating == 0)
                    meta += ' Videospace user rating: no ratings.'
                else
                    meta += ' Videospace user rating: '+this.resource.user_reviews_rating+'/5'
                meta += ' Reviews: '+this.resource.user_reviews_count
                meta += ' Releases: '+this.resource.releases_count
            }
            return meta

        },
        tmdbLink(){

            switch(this.resource.type){
                case 1:
                    return 'https://www.themoviedb.org/movie/'+this.resource.tmdb_id
                case 2:
                    return 'https://www.themoviedb.org/tv/'+this.resource.tmdb_id
                case 5:
                    return 'https://www.themoviedb.org/tv/'+this.resource.show_id_tmdb+'/season/'+this.resource.season_number+'/episode/'+this.resource.episode_number

                default:
                    return ""
            }

        },

        //Produces basicInfo for upper info section
        basicInfo(){
            if(this.resource)
                return [
                    {
                        visible: Boolean(this.resource.belongs_to_show),
                        type: 'string',
                        name: this.$t('episode of'),
                        content: this.resource.belongs_to_show ? this.resource.belongs_to_show.name+' ('+this.resource.belongs_to_show.year+')' : null,
                        link_to: this.resource.belongs_to_show ? '/movie/'+this.resource.belongs_to_show.public_id : null,
                    },
                    {
                        visible: this.resource.number_of_seasons,
                        type: 'string',
                        name: this.$t('seasons amount'),
                        content: this.resource.number_of_seasons
                    },
                    {
                        visible: this.resource.number_of_episodes,
                        type: 'string',
                        name: this.$t('episodes amount'),
                        content: this.resource.number_of_episodes
                    },
                    {
                        visible: this.resource.season_number,
                        type: 'string',
                        name: this.$t('season'),
                        content: this.resource.season_number
                    },
                    {
                        visible: this.resource.episode_number,
                        type: 'string',
                        name: this.$t('episode'),
                        content: this.resource.episode_number
                    },
                    {
                        visible: this.resource.countries.length > 0 ? true : false,
                        type: 'array',
                        name: this.$t('country'),
                        name_plural: this.$t('countries'),
                        content: this.resource.countries,
                        link_base: '/movies?co='
                    },
                    {
                        visible: this.resource.genres.length > 0 ? true : false,
                        type: 'array',
                        name: this.$t('genre'),
                        name_plural: this.$t('genres'),
                        content: this.resource.genres.slice(0,5),
                        content_count: this.resource.genres.length,
                        link_base: '/movies?ge='
                    },
                    {
                        visible: this.resource.directors.length > 0 ? true : false,
                        type: 'array',
                        name: this.$t('directed by'),
                        name_plural: this.$t('directors'),
                        content: this.resource.directors.slice(0,5),
                        content_count: this.resource.directors.length,
                        link_base: '/person/',
                        see_all_link: this.baseUrl+'/'+this.publicId+'/cast_crew',
                    },
                    {
                        visible: this.resource.actors.length > 0 ? true : false,
                        type: 'array',
                        name: this.$t('starring'),
                        content: this.resource.actors.slice(0,5),
                        content_count: this.resource.actors.length,
                        link_base: '/person/',
                        see_all_link: this.baseUrl+'/'+this.publicId+'/cast_crew',
                    },
                    {
                        visible: this.resource.released_at && this.$day(this.resource.released_at).unix() > this.$day().unix() ? true : false,
                        type: 'string',
                        name: this.$t('coming soon'),
                        content: this.$day(this.resource.released_at).format('DD/MM/YYYY')
                    },
                    {
                        visible: this.resource.seen_count_auth > 0 ? true : false,
                        type: 'string',
                        name: this.$t('you have seen this'),
                        content: this.$t('yes'),
                    },
                    {
                        visible: this.resource.adult,
                        type: 'string',
                        name: this.$t('adults only'),
                        content: this.$t('yes')
                    },
                    {
                        visible: this.resource.seen_count_auth == 0 && this.resource.want_see_count_auth > 0? true : false,
                        type: 'string',
                        name: this.$t('you want to see this'),
                        content: this.$t('yes'),
                    },
                ]

            return []
        },
        //produces complete info for lover info section
        completeInfo(){
            if(this.resource)
                return [
                    {
                        visible: this.resource.type,
                        type: 'string',
                        name: this.$t('content type'),
                        content: this.$t('movie type '+this.resource.type)
                    },
                    {
                        visible: this.resource.number_of_seasons,
                        type: 'string',
                        name: this.$t('seasons amount'),
                        content: this.resource.number_of_seasons
                    },
                    {
                        visible: this.resource.number_of_episodes,
                        type: 'string',
                        name: this.$t('episodes amount'),
                        content: this.resource.number_of_episodes
                    },
                    {
                        visible: this.resource.season_number,
                        type: 'string',
                        name: this.$t('season'),
                        content: this.resource.season_number
                    },
                    {
                        visible: this.resource.episode_number,
                        type: 'string',
                        name: this.$t('episode'),
                        content: this.resource.episode_number
                    },
                    {
                        visible: this.resource.akas,
                        type: 'string',
                        name: this.$t('akas'),
                        content: this.resource.akas
                    },
                    {
                        visible: this.resource.countries.length > 0 ? true : false,
                        type: 'array',
                        name: this.$t('country'),
                        name_plural: this.$t('countries'),
                        content: this.resource.countries,
                        link_base: '/movies?co='
                    },
                    {
                        visible: this.resource.year ? true : false,
                        type: 'string',
                        name: this.$t('year'),
                        content: this.resource.year,
                        link_to: '/movies?year='+this.resource.year
                    },
                    {
                        visible: this.resource.released_at ? true : false,
                        type: 'string',
                        name: this.$t('release date'),
                        content: this.$day(this.resource.released_at).format('DD/MM/YYYY')
                    },
                    {
                        visible: this.resource.runtime ? true : false,
                        type: 'string',
                        name: this.$t('runtime'),
                        content: this.resource.runtime+' '+this.$t('minutes'),
                    },
                    {
                        visible: this.resource.adult,
                        type: 'string',
                        name: this.$t('adults only'),
                        content: this.$t('yes')
                    },
                    {
                        visible: this.resource.tmdb_id,
                        type: 'string',
                        name: this.$t('tmdb'),
                        content: this.$t('opens tmdb'),
                        link_to: this.tmdbLink,
                        link_target: '_blank'
                    },
                    {
                        visible: this.resource.imdb_id,
                        type: 'string',
                        name: this.$t('imdb'),
                        content: this.$t('opens imdb'),
                        link_to: 'https://www.imdb.com/title/'+this.resource.imdb_id,
                        link_target: '_blank'
                    },
                    {
                        visible: this.resource.genres.length > 0 ? true : false,
                        type: 'array',
                        name: this.$t('genre'),
                        name_plural: this.$t('genres'),
                        content: this.resource.genres.slice(0,5),
                        content_count: this.resource.genres.length,
                        link_base: '/movies?ge='
                    },
                    {
                        visible: this.resource.directors.length > 0 ? true : false,
                        type: 'array',
                        name: this.$t('directed by'),
                        name_plural: this.$t('directors'),
                        content: this.resource.directors.slice(0,5),
                        content_count: this.resource.directors.length,
                        link_base: '/person/',
                        see_all_link: this.baseUrl+'/'+this.publicId+'/cast_crew',
                    },
                    {
                        visible: this.resource.producers.length > 0 ? true : false,
                        type: 'array',
                        name: this.$t('produced by'),
                        name_plural: this.$t('produced by'),
                        content: this.resource.producers.slice(0,5),
                        content_count: this.resource.producers.length,
                        link_base: '/person/',
                        see_all_link: this.baseUrl+'/'+this.publicId+'/cast_crew',
                    },
                    {
                        visible: this.resource.writers.length > 0 ? true : false,
                        type: 'array',
                        name: this.$t('writer'),
                        name_plural: this.$t('writers'),
                        content: this.resource.writers.slice(0,5),
                        content_count: this.resource.writers.length,
                        link_base: '/person/',
                        see_all_link: this.baseUrl+'/'+this.publicId+'/cast_crew',
                    },
                    {
                        visible: this.resource.composers.length > 0 ? true : false,
                        type: 'array',
                        name: this.$t('composer'),
                        name_plural: this.$t('composers'),
                        content: this.resource.composers.slice(0,5),
                        content_count: this.resource.composers.length,
                        link_base: '/person/',
                        see_all_link: this.baseUrl+'/'+this.publicId+'/cast_crew',
                    },
                    {
                        visible: this.resource.actors.length > 0 ? true : false,
                        type: 'array',
                        name: this.$t('starring'),
                        content: this.resource.actors.slice(0,5),
                        content_count: this.resource.actors.length,
                        link_base: '/person/',
                        see_all_link: this.baseUrl+'/'+this.publicId+'/cast_crew',
                    },
                    {
                        visible: this.resource.companies.length > 0 ? true : false,
                        type: 'array',
                        name: this.$t('production company'),
                        name_plural: this.$t('production companies'),
                        content: this.resource.companies.slice(0,5),
                        content_count: this.resource.companies.length,
                        link_base: '/company/',
                    },
                    {
                        visible: this.resource.languages.length > 0 ? true : false,
                        type: 'array',
                        name: this.$t('spoken languages'),
                        content: this.resource.languages,
                        content_count: this.resource.languages.length,
                        link_base: '/movies?ls='
                    },
                    {
                        visible: this.resource.certifications.length > 0 ? true : false,
                        type: 'array',
                        name: this.$t('certifications'),
                        content: this.resource.certifications,
                        content_count: this.resource.certifications.length,
                        link_base: '/movies?ce=',
                        country: true,
                    },
                    {
                        visible: this.resource.tmdb_at ? true : false,
                        type: 'string',
                        name: this.$t('tmdb at'),
                        content: this.$day(this.resource.tmdb_at).format('DD/MM/YYYY')
                    },
                    {
                        visible: this.resource.updated_at && this.resource.tmdb_at != this.resource.updated_at ? true : false,
                        type: 'string',
                        name: this.$t('page updated at'),
                        content: this.$day(this.resource.updated_at).format('DD/MM/YYYY')
                    },
                    {
                        visible: this.resource.created_at ? true : false,
                        type: 'string',
                        name: this.$t('page created at'),
                        content: this.$day(this.resource.created_at).format('DD/MM/YYYY')
                    },
                ]

            return []
        },
        //produce user action buttons using resource when it is available
        userActionButtons(){

            return [
                {
                    id: 'seen',
                    title: 'have seen',
                    icon: 'mdi-eye-outline',
                    icon_selected: 'mdi-eye',
                    value_name: 'seen_count_auth',
                    value: this.resource.seen_count_auth,
                    action: 'add_seen',
                    //action: 'toggle',
                    badge: true,
                    list_value: true,
                    //api_post_action: 'my_seen_collection_toggle',
                    api_post_action: 'add_seen',
                    //api_post_action: 'my_seen_collection_toggle',
                    api_post_values: {model: this.resource.model, model_id: this.resource.id}
                },
                {
                    id: 'want',
                    title: 'want see',
                    icon: 'mdi-eye-plus-outline',
                    icon_selected: 'mdi-eye-plus',
                    value_name: 'want_see_count_auth',
                    value: this.resource.want_see_count_auth,
                    action: 'toggle',
                    list_value: true,
                    api_post_action: 'my_want_see_collection_toggle',
                    api_post_values: {model: this.resource.model, model_id: this.resource.id},
                    emits: 'want_see'
                },
                {
                    id: 'like',
                    title: 'like',
                    icon: 'mdi-heart-outline',
                    icon_selected: 'mdi-heart',
                    value_name: 'likes_count_auth',
                    secondary_value_name: 'likes_count',
                    value: this.resource.likes_count_auth,
                    action: 'toggle',
                    api_post_action: 'reactions',
                    api_post_values: {model: this.resource.model, model_id: this.resource.id}
                },
                {
                    id: 'list',
                    title: 'add to list',
                    icon: 'mdi-playlist-plus',
                    icon_selected: 'mdi-playlist-check',
                    value_name: 'list_entries_count_auth',
                    value: this.resource.list_entries_count_auth,
                    action: 'open-list',
                    badge: true,
                },
            ]

        },
        //produce subPageButtons
        subPageButtons(){
            if(this.resource)
                return[
                    {
                        id: 'main',
                        route: '',
                        label: 'details',
                    },
                    {
                        id: 'releases',
                        route: '/releases',
                        label: 'releases',
                        value: this.resource.releases_count,
                    },
                    {
                        id: 'pictures',
                        route: '/photos',
                        label: 'pictures',
                        value: this.resource.pictures_count,
                    },
                    {
                        id: 'reviews',
                        route: '/reviews',
                        label: 'reviews',
                        value: this.resource.user_reviews_count,
                    },
                    {
                        id: 'collections',
                        route: '/user_collections',
                        label: 'user collections',
                        value: this.resource.list_entries_count,
                    },
                    {
                        id: 'discussions',
                        route: '/posts',
                        label: 'discussions',
                        value: this.resource.posts_count,
                    },
                    {
                        id: 'crew',
                        route: '/cast_crew',
                        label: 'cast crew',
                        value: this.resource.crew_count},
                    {
                        id: 'movie_connections',
                        route: '/movie_connections',
                        label: 'movie connections',
                        value: this.resource.movie_connections_count,
                    },
                    {
                        id: 'buying_options',
                        route: '/buying_options',
                        label: 'buying options',
                    },
                    {
                        id: 'videos',
                        route: '/videos',
                        label: 'videos',
                        value: this.resource.videos_count,
                    },
                    {
                        id: 'tools',
                        label: 'tools',
                        fixed_color: 'red',
                        menu: [
                            {
                                id: 'edit',
                                route: '/edit',
                                label: 'edit',
                            },
                            {
                                id: 'history',
                                route: '/history',
                                label: 'page history',
                            },
                            {
                                id: 'contact',
                                route: '/contact',
                                label: 'contact us',
                            },
                            {
                                id: 'delete',
                                dialog: 'delete',
                                label: 'delete',
                                fixed_color: 'red',
                            },
                        ]
                    },
                ]

            return []
        }
    },
    created(){
        this.$root.$on('videospace', function(payload){

            if(this.resource.id == payload.model_id && this.resource.model.toLowerCase() == payload.model.toLowerCase()) {

                //update existing item with received data
                for (const [key, value] of Object.entries(payload.data)) {

                    if (value == "sub") this.resource[key] = this.resource[key] - 1 > -1 ? this.resource[key] - 1 : 0 //subtract from original value. do not go under 0
                    if (value == "add") this.resource[key] = this.resource[key] + 1 //add to original value

                    if (value != "add" && value != "sub") this.resource[key] = value //update value

                }
            }

        }.bind(this))
    }
}
</script>

<style scoped>

</style>
